import { useColorModes } from '@coreui/vue-pro'

export const useThemeStore = defineStore('theme', () => {
  const theme = ref(useColorModes().colorMode.value)

  const toggleTheme = () => {
    const { setColorMode } = useColorModes()
    theme.value = theme.value === 'dark' ? 'light' : 'dark'
    setColorMode(theme.value)
  }

  return {
    theme,
    toggleTheme
  }
})
